export function normalizeShipStaffRecord(item = {}) {
  return {
    shipStaffId: item.shipStaffId || 0,
    name: item.name || "",
    email: item.email || "",
    phone: item.phone || "",
    address: item.address || "",
    shipName: item.shipName || "",
  };
}
